var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.loader
      ? _c(
          "div",
          {
            staticClass: "p-10",
            staticStyle: { height: "calc(100vh - 100px)", overflow: "scroll" }
          },
          [
            _c("v-layout", [_c("v-flex", { attrs: { xs0: "", md10: "" } })], 1),
            _vm._v(" "),
            _vm.user.officer_role === 3 ||
            _vm.user.officer_role === 4 ||
            _vm.user.officer_role === 5
              ? _c(
                  "v-layout",
                  { attrs: { wrap: "" } },
                  [
                    _c("v-flex", { attrs: { xs12: "", md2: "" } }, [
                      _c("div", { staticClass: "elc-header" }, [
                        _c("h2", { staticClass: "p-10" }, [
                          _vm._v(
                            "\n                        Registered Status\n                    "
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs12: "", md3: "" } }, [
                      _c("div", { staticClass: "p-16" }, [
                        _c("span", { staticClass: "elc-header-active" }, [
                          _c("p"),
                          _vm._v("Active")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "elc-header-Inactive" }, [
                          _c("p"),
                          _vm._v("Inactive")
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "elc-header-Total" }, [
                          _c("p"),
                          _vm._v("Total")
                        ])
                      ])
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.user.officer_role === 3 ||
            _vm.user.officer_role === 4 ||
            _vm.user.officer_role === 5
              ? _c(
                  "v-flex",
                  { staticClass: "p-8", attrs: { xs12: "" } },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c(
                          "v-flex",
                          {
                            staticClass: "elc-card-club-count",
                            staticStyle: { padding: "6px" },
                            attrs: { xs12: "", sm6: "", lg3: "" }
                          },
                          [
                            _c(
                              "v-card",
                              { staticClass: "elc-registered-sataus" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "p-10 elc-registered-sataus-total"
                                  },
                                  [_c("span", [_vm._v("Nodal Officer")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "elc-registered-sataus-active-inacitve"
                                  },
                                  [
                                    _c("span", { staticClass: "elc-active" }, [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.officerCountData
                                              .registerOfficerCount
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "elc-inactive" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.officerCountData
                                                .remainingOfficerCount
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "elc-total" }, [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.officerCountData.officer)
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          {
                            staticClass: "elc-card-club-count",
                            staticStyle: { padding: "6px" },
                            attrs: { xs12: "", sm6: "", lg3: "" }
                          },
                          [
                            _c(
                              "v-card",
                              { staticClass: "elc-registered-sataus" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "p-10 elc-registered-sataus-total"
                                  },
                                  [_c("span", [_vm._v("Members")])]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "elc-registered-sataus-active-inacitve"
                                  },
                                  [
                                    _c("span", { staticClass: "elc-active" }, [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.officerCountData
                                              .registerMemberCount
                                          )
                                        )
                                      ])
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "elc-inactive" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.officerCountData
                                                .remainingMemberCount
                                            )
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "elc-total" }, [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.officerCountData.members)
                                        )
                                      ])
                                    ])
                                  ]
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "both" } }),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { wrap: "" } },
              [
                _c("v-flex", { attrs: { xs12: "", md2: "" } }, [
                  _c("div", { staticClass: "elc-header" }, [
                    _c("h2", { staticClass: "p-10" }, [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.allClubsData.activeClubCount +
                              _vm.allClubsData.deActiveClubCount
                          ) + " "
                        )
                      ]),
                      _vm._v("Clubs In\n                        Arvalli")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("v-flex", { attrs: { xs12: "", md3: "" } }, [
                  _c("div", { staticClass: "p-16" }, [
                    _c("span", { staticClass: "elc-header-active" }, [
                      _c("p"),
                      _vm._v("Active")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "elc-header-Inactive" }, [
                      _c("p"),
                      _vm._v("Inactive")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "elc-header-Total" }, [
                      _c("p"),
                      _vm._v("Total")
                    ])
                  ])
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { wrap: "" } },
              [
                _c(
                  "v-flex",
                  {
                    staticClass: "p-8 elc-card-club-count",
                    attrs: { xs12: "" }
                  },
                  _vm._l(_vm.clubData, function(data) {
                    return _c(
                      "div",
                      {
                        staticClass: "elc-clubcount",
                        on: {
                          click: function($event) {
                            _vm.filterMember(data.type)
                          }
                        }
                      },
                      [
                        _c("v-card", { staticClass: "elc-clubcount-spacing" }, [
                          _c(
                            "div",
                            { staticClass: "p-10 elc-clubCount-Arvalli-total" },
                            [_c("span", [_vm._v(_vm._s(data.type))])]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "elc-clubcount-active-inacitve" },
                            [
                              _c("span", { staticClass: "elc-active" }, [
                                _c("p", [_vm._v(_vm._s(data.activeCount))])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "elc-inactive" }, [
                                _c("p", [_vm._v(_vm._s(data.deActiveCount))])
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "elc-total" }, [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      data.activeCount + data.deActiveCount
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        ])
                      ],
                      1
                    )
                  })
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticStyle: { clear: "both" } }),
            _vm._v(" "),
            _c(
              "v-layout",
              { attrs: { wrap: "" } },
              [
                _c("v-flex", { attrs: { xs12: "", sm2: "" } }, [
                  _c("div", { staticClass: "elc-header" }, [
                    _c("h2", { staticClass: "p-10" }, [
                      _vm._v("Clubs In Taluka")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("v-flex", { attrs: { xs12: "", md7: "" } }, [
                  _c("div", { staticClass: "p-16" }, [
                    _c("span", { staticClass: "elc-header-active" }, [
                      _c("p"),
                      _vm._v("Active")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "elc-header-Inactive" }, [
                      _c("p"),
                      _vm._v("Inactive")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "elc-header-Total" }, [
                      _c("p"),
                      _vm._v("Total")
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm3: "" } },
                  [
                    _c("v-text-field", {
                      staticClass: "p-12",
                      attrs: {
                        "append-icon": "search",
                        label: "Search",
                        "single-line": "",
                        "hide-details": ""
                      },
                      model: {
                        value: _vm.searchTask,
                        callback: function($$v) {
                          _vm.searchTask = $$v
                        },
                        expression: "searchTask"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _vm.talukaData.length == 0 || _vm.serachFlag
              ? _c(
                  "div",
                  { staticClass: "p-10 elc-card-club-count" },
                  [
                    _c("v-card", { staticClass: "elc-no-data" }, [
                      _c("span", [_vm._v("No clubs found")])
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "p-8 elc-card-club-count" },
              _vm._l(_vm.filteredClubs, function(data) {
                return _c(
                  "v-card",
                  { staticClass: "elc-clubintaluka" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "elc-club-taluka",
                        on: {
                          click: function($event) {
                            _vm.filterMemberTalukaName(data)
                          }
                        }
                      },
                      [
                        _c(
                          "v-layout",
                          { attrs: { wrap: "" } },
                          [
                            _c("v-flex", { attrs: { xs12: "", md6: "" } }, [
                              _c("h3", [_vm._v(_vm._s(data.name) + " ")])
                            ]),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "text-xs-center",
                                attrs: { xs4: "", md2: "" }
                              },
                              [
                                _c("span", { staticClass: "elc-active" }, [
                                  _vm._v(_vm._s(data.activeCount))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "text-xs-center",
                                attrs: { xs4: "", md2: "" }
                              },
                              [
                                _c("span", { staticClass: "elc-inactive" }, [
                                  _vm._v(_vm._s(data.deActiveCount))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              {
                                staticClass: "text-xs-center",
                                attrs: { xs4: "", md2: "" }
                              },
                              [
                                _c("span", { staticClass: "elc-total" }, [
                                  _vm._v(
                                    _vm._s(
                                      data.activeCount + data.deActiveCount
                                    )
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(data.byType, function(val) {
                      return _c(
                        "div",
                        {
                          staticClass: "elc-club-subtaluka",
                          on: {
                            click: function($event) {
                              _vm.filterMemberTaluka(data.name, val)
                            }
                          }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", md3: "", lg6: "" } },
                                [_c("h3", [_vm._v(_vm._s(val.type))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: { xs4: "", md3: "", lg2: "" }
                                },
                                [_c("span", [_vm._v(_vm._s(val.activeCount))])]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: { xs4: "", md3: "", lg2: "" }
                                },
                                [
                                  _c("span", [
                                    _vm._v(_vm._s(val.deActiveCount))
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-xs-center",
                                  attrs: { xs4: "", md3: "", lg2: "" }
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        val.activeCount + val.deActiveCount
                                      )
                                    )
                                  ])
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    })
                  ],
                  2
                )
              })
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.loader
      ? _c(
          "div",
          { staticClass: "center_loader" },
          [
            _c("v-progress-circular", {
              attrs: { indeterminate: "", color: "primary" }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c120c7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c120c7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClubCount/ClubCount.vue
// module id = null
// module chunks = 